import styled from 'styled-components';

import { TextButton } from '../buttons';

export const StyledDialog = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 600px;
  max-height: calc(100vh - 100px);
  background: var(--p2l-background-main-color, #fff);
  border-radius: 4px;
  box-shadow:
    0 2px 20px rgba(0, 0, 0, 0.15),
    0 30px 20px -20px rgba(0, 0, 0, 0.2);
  will-change: opacity, transform, transition;

  @media (max-width: 960px) {
    max-width: 100%;
    height: 100%;
    max-height: 100vh;
    border-radius: 0;
  }
`;

export const StyledDialogBackdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: #00000080;
`;

export const StyledDialogWrapper = styled.div<{ $open: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1201;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  opacity: ${({ $open }) => ($open ? '1' : '0')};
  transition: ${({ $open }) => ($open ? 'all 0.24s ease' : 'all 0.24s ease 0.12s')};
  will-change: opacity, transition;
  pointer-events: ${({ $open }) => ($open ? 'all' : 'none')};

  @media (max-width: 960px) {
    padding: 0;
  }

  ${StyledDialog} {
    opacity: ${({ $open }) => ($open ? '1' : '0')};
    transform: ${({ $open }) => ($open ? 'translate3d(0, 0, 0)' : 'translate3d(0, -30px, 0)')};
    transition: ${({ $open }) => ($open ? 'all 0.24s ease 0.12s' : 'all 0.24s ease')};

    [data-dialog-header],
    [data-dialog-body],
    [data-dialog-footer] {
      transition: opacity 0.3s ease;
    }
  }
`;

export const DialogCloseButton = styled(TextButton)``;

export const DialogTitle = styled.h3`
  margin: 0;
  font-size: 16px;
`;
